// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"97167b0e","80":"fc0ac416","236":"5db7e3ce","243":"45fd867d","310":"b690eccf","352":"a4e855ee","385":"83ac6432","411":"b7abaaab","529":"07d20a10","623":"ae857522","665":"15eda31c","700":"4f9ce3c3","715":"c4921874","892":"1db78500"}[chunkId] + ".chunk.js";
};